import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

export enum AlertType {
  Danger = 'danger',
  Info = 'info'
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class AlertComponent implements OnInit {
  @Input()
  type = AlertType.Info;

  @Input()
  theme: 'light' | 'dark' = 'dark';

  constructor() { }

  ngOnInit() {
  }

}
